<template>
  <div>
    <VuePlyr class="plyr__video-embed" :options="options">
      <div>
        <iframe src="https://youtu.be/JPyMDA6IW5g" allowtransparencys frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </div>
    </VuePlyr>
  </div>
</template>

<script>
import { VuePlyr } from 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css'

export default {
  components: {
    VuePlyr
  },
  data () {
    return {
      options: {
        ready: false,
        autoplay: true,
        muted: true
      }
    }
  },
  methods: {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/guideQuery.vue